import { Button, Flex, Spacer } from '@chakra-ui/react'
import { capitalize } from 'lodash-es'

import useAPIWrapper from '@/client/hooks/useAPIWrapper'
import { RPCRefresh } from '@/client/rpc'
import {
  getCAWConsentFormInputs,
  getCAWConsentResponses,
} from '@/client/services/formInputs/cawConsentFormInputs'
import { COLLEGE_ADMISSIONS_WORKSHOPS_WORLD_SLUG } from '@/client/services/worlds/constants'

import { useToaster } from '@/components/Toast/useToaster'
import Form from '@/components/UI/Form/Form'
import type { FormValues } from '@/components/UI/Form/types'
import ModalV3 from '@/components/UI/Modal/ModalV3'

export default function CAWConsentModal({
  open,
  onClose,
  type,
}: {
  open: boolean
  onClose: () => void
  type: 'learner' | 'tutor'
}): JSX.Element {
  const toast = useToaster()
  const [handleSubmit] = useAPIWrapper(
    async (formValues: FormValues) => {
      const responses = getCAWConsentResponses({ formValues })
      await RPCRefresh.submitProgramConsent({
        type,
        worldSlug: COLLEGE_ADMISSIONS_WORKSHOPS_WORLD_SLUG,
        responses,
      })
      toast({
        title: `Submitted ${capitalize(type)} Consent`,
        status: 'success',
      })
      onClose()
    },
    [onClose, toast, type],
    `Submit CAW ${capitalize(type)} Consent`
  )
  const inputs = getCAWConsentFormInputs({ type })

  return (
    <ModalV3
      open={open}
      title={`Complete ${capitalize(type)} Consent`}
      size="3xl"
      body={() => (
        <Form
          name="CAWConsentForm"
          blocks={inputs}
          onSubmit={handleSubmit}
          FooterComponent={({ submitting }) => (
            <Flex mt="16px">
              <Spacer />
              <Button isLoading={submitting} type="submit">
                Submit
              </Button>
            </Flex>
          )}
        />
      )}
      onClose={onClose}
    />
  )
}
